var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ct-details",on:{"click":_vm.handleClickDetails}},[_c('img',{attrs:{"src":require("@img/icons/icon-detail.svg?inline"),"alt":"detail icon"}}),_c('p',[_vm._v("VER DETALHES")])])
}
var staticRenderFns = []

export { render, staticRenderFns }